import * as React from 'react'
import { BodyWithMenu } from '../../components/organisms/Menu'
import { MarkNotificationAsViewed, getInvestorDashboard } from '../../globals/ApiHooks';
import { createEnDaContent, lang, translateContent } from '../../globals/Translations';
import { TranslatedTerms } from '../../globals/TranslatedTerms';
import CloseIcon from '@mui/icons-material/Close';
import { IsTablet, useWindowSize } from '../../globals/UIHooks';
import { UINotification } from '../../shared/Notifications';
import styled from 'styled-components';
import colors from '../../globals/colors';
import { NiceDate } from '../../shared/UIFormatting';
import { ColumnFlexBox, RowFlexBox } from '../../components/templates/Wrappers';
import FBContent from '../../components/templates/FBContent';

const CloseButton = styled.button`
  transition: 100ms ease;
  color: ${colors.light};
  background-color: ${colors.dark};
  font-weight: 700;
  width: 50px;
  padding-left: 0px;
  padding-right: 0px;
  :active, :hover, :focus{
    color: ${colors.light};
    font-weight: 700;

  }
`

const NotificationListItemWrapper = styled.div<{ active: boolean }>`
  padding: 10px 6px 10px 16px;
  margin: 4px 14px;
  transition: 350ms ease;
  text-decoration: none;
  border-radius: 10px;
  cursor: pointer;
  background-color: ${(props) => props.active ? colors.light : colors.primaryOpacity};
  :hover{
    background-color: ${colors.lighter};
    transition: 350ms ease;
    color: ${colors.primary};
  }
`

export const NotificationsListItem: React.FC<{ notification: UINotification, setActiveNotification: (notification: UINotification) => void, activeNotification?: UINotification }> = ({ notification, setActiveNotification, activeNotification }) => {
  const [localViewed, setLocalViewed] = React.useState(!!notification.viewed)

  const handleClick = async () => {
    setLocalViewed(true)
    setActiveNotification(notification)
    if (!localViewed) await MarkNotificationAsViewed(notification.notificationId)
  }

  return (
    <NotificationListItemWrapper onClick={handleClick} active={!!activeNotification && activeNotification.notificationId === notification.notificationId}>
      <ColumnFlexBox>
        {localViewed ? <span>{notification.title}</span> : <b>{notification.title}</b>}
        <span className="light">{NiceDate(notification.created)}</span>
      </ColumnFlexBox>
    </NotificationListItemWrapper>
  )
}

export const NotificationsPage: React.FC = () => {
  const [notifications, setNotifications] = React.useState<UINotification[]>([])
  const [activeNotification, setActiveNotification] = React.useState<UINotification>()

  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    (async () => {
      setLoading(true)
      const dashoard = await getInvestorDashboard()
      if (dashoard?.notifications) setNotifications(dashoard?.notifications)
      setLoading(false)
    })()
  }, [])

  const tablet = IsTablet(useWindowSize().width)


  return (
    <BodyWithMenu loading={loading}>
      <h1 style={{ margin: 0 }}>{lang(TranslatedTerms.MESSAGES)}</h1>
      <ColumnFlexBox style={{ display: tablet ? 'flex' : 'grid', gridTemplateColumns: '2fr 3fr' }}>
        <ColumnFlexBox style={{ overflow: 'scroll', width: '100%', marginTop: 12 }}>
          {notifications && notifications.map((notification, key) => <NotificationsListItem notification={notification} key={key} activeNotification={activeNotification} setActiveNotification={setActiveNotification} />)}
          {!loading && notifications && notifications.length === 0 && <span>{translateContent(createEnDaContent("No messages yet.", "Ingen beskeder endnu."))}</span>}
        </ColumnFlexBox>
        {!tablet && notifications.length > 0 && <ColumnFlexBox style={{ alignItems: 'center', marginTop: 64 }}>
          <span>{translateContent(createEnDaContent("Click on the messages to see more details.", "Klik på beskederne for at se flere detaljer."))}</span>
        </ColumnFlexBox>}
      </ColumnFlexBox>
      <ColumnFlexBox style={{
        transition: "350ms ease",
        position: 'fixed', top: 0, right: activeNotification ? 0 : '-100vw', bottom: 0, width: tablet ? '100vw' : '40vw',
        boxShadow: activeNotification ? colors.defaultShadow : "", overflow: 'scroll', zIndex: 100, backgroundColor: colors.lightest,
        paddingTop: 32, paddingLeft: 12, paddingRight: 12, paddingBottom: 64
      }}>
        <RowFlexBox style={{alignItems: 'center', marginBottom: 12}}>
          <CloseButton style={{ marginRight: 12}} onClick={() => setActiveNotification(undefined)}><CloseIcon style={{ color: colors.lightest }} /></CloseButton>
          <span className="light">{activeNotification && lang(TranslatedTerms.CREATED) + ": " + NiceDate(activeNotification?.created)}</span>
        </RowFlexBox>
        <h4>{activeNotification?.title}</h4>
        {activeNotification?.content && <FBContent content={activeNotification.content.data} contentType={activeNotification.content.contentType} />}
      </ColumnFlexBox>
    </BodyWithMenu>
  )
};
